import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const Cancel = () => {
  return (
    <div className="min-h-screen bg-[#0b0b0b] text-white flex items-center justify-center px-6">
      <div
        className="max-w-lg w-full text-center space-y-6 py-20"
        data-testid="cancel-page"
      >
        <XCircle className="mx-auto text-zinc-500" size={56} />
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tight">
          Checkout Cancelled
        </h1>
        <p className="text-zinc-400 text-xs tracking-widest uppercase">
          Your gear is still in the bag. Pick up where you left off.
        </p>
        <Link
          to="/"
          className="inline-block bg-white text-black font-heading font-bold text-xs tracking-widest uppercase px-8 py-4 hover:bg-zinc-300"
          data-testid="cancel-home-btn"
        >
          Back to Shop
        </Link>
      </div>
    </div>
  );
};

export default Cancel;
